import { Injectable, Inject } from '@angular/core';
import { Observable ,  ReplaySubject } from 'rxjs';
import { CompanyInfoFilters } from './company-info-filters.model';

@Injectable()
export class CompanyInfoFiltersService {
  private subject: ReplaySubject<CompanyInfoFilters>;
  private _lastFilters: CompanyInfoFilters;

  private _suppressUpdate = false;

  constructor() {
    this.subject = new ReplaySubject<CompanyInfoFilters>(1);
    if (!this._suppressUpdate) {
      if (this._lastFilters) {
        this.updateFilters(this._lastFilters.copy());
      } else {
        this.updateFilters(this.createDefaultFilter());
      }
    }
  }

  updateFilters(filters: CompanyInfoFilters) {
    this._lastFilters = filters;
    this.subject.next(filters);
  }

  clearFilters() {
    if (this._lastFilters) {
      this._lastFilters.reset();
    }
  }

  getFilters(): Observable<CompanyInfoFilters> {
    return this.subject.asObservable();
  }

  createDefaultFilter(): CompanyInfoFilters {
    return new CompanyInfoFilters(
      [],
      [],
      [],
      [],
      null,
      null
    );
  }
}
